import React, { Fragment } from 'react';
import { i18n } from 'utils/i18n';

const passengerType = () => <span className='vis-hidden'>{i18n('vehicle_details_passengers')}</span>;
const defaultFilters = [
  {
    keyPath: 'filters.CLASS.filterCode',
    type: 'checkbox',
  },
  {
    keyPath: 'filters.PASSENGERS.filterCode',
    type: 'checkbox',
    isRadio: true,
    // eslint-disable-next-line
    labelHandler: (label, value, lowestCarFilterPrices) =>
      i18n(
        'vehicle_filters_and_up_passengers',
        [
          <Fragment key={value}>
            {label}
            {passengerType()}
          </Fragment>,
        ],
        { jsx: true }
      ),
  },
  {
    keyPath: 'filters.BAGS.filterCode',
    isRadio: true,
    type: 'select',
    optionDecorateKey: 'vehicle_filters_and_up_passengers',
  },
  {
    keyPath: 'filters.TRANSMISSION.filterCode',
    type: 'select',
    isSingleSelect: true,
  },
  {
    keyPath: 'filters.DRIVE.filterCode',
    type: 'checkbox',
    optionDecorateKey: 'vehicle_filters_and_drive',
  },
];

export const filters = defaultFilters;
